import { REQUEST_TIME_SLOTS, REQUEST_TIME_SLOTS_ERROR, REQUEST_TIME_SLOTS_SUCCESS, UPDATE_SCHEDULE_SLOT, UPDATE_SCHEDULE_SLOT_ERROR, UPDATE_SCHEDULE_SLOT_SUCCESS } from './Constants';

// userReducer.js
const initialState = {
    loading: false,
    error: null,
};

export const timeSlotReducer = (state = initialState, action) => {
    switch (action.type) {
    case REQUEST_TIME_SLOTS:
        return { ...state, updatedSheduleData : null, loading: true };
    case REQUEST_TIME_SLOTS_SUCCESS:
        return { ...state, timeSlotData: action.data, loading: false };
    case REQUEST_TIME_SLOTS_ERROR:
        return { ...state, loading: false };
    case UPDATE_SCHEDULE_SLOT:
        return { ...state, loading: true };
    case UPDATE_SCHEDULE_SLOT_SUCCESS:
        return { ...state, updatedSheduleData: action.data, loading: false };
    case UPDATE_SCHEDULE_SLOT_ERROR:
        return { ...state, loading: false };
    default:
        return state;
    }
};
